import { combineReducers } from "redux";
import AppVariablesReducer, { AppVariablesState } from "./app_variables";

export interface SettingsState {
  app_variables: AppVariablesState;
}
export default combineReducers({
  app_variables: AppVariablesReducer,
});
